import styled from 'styled-components';
import IconButton from '@mui/material/IconButton';

import { FileFooter, FileLayout } from 'ui/Feed/File/styles';

export const EvidenceFilesList = styled.div`
  width: 100%;
`;

export const EvidenceFileLayout = styled(FileLayout)`
  padding: ${({ theme }) => theme.spacing(1, 0)};
`;

export const EvidenceFileFooter = styled(FileFooter)`
  align-items: center;
`;

export const DownloadLink = styled.a`
  display: flex;
  color: inherit;
`;

export const RemoveButton = styled(IconButton)`
  margin-left: ${({ theme }) => theme.spacing(1)};
`;
